'use client';

import { Button, Card } from '@trakd/ui';
import Link from 'next/link';
import { useEffect, type ReactElement } from 'react';
import { TbAlertTriangle, TbHome, TbRefresh } from 'react-icons/tb';

import { AmbientOrbs } from './(app)/_components/ambient-orbs';

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalRouteError({ error, reset }: Props): ReactElement {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="bg-bg relative flex min-h-screen items-center justify-center px-6">
      <AmbientOrbs subtle />
      <Card variant="elevated" padding="lg" className="relative z-10 w-full max-w-md text-center">
        <div className="mb-6 flex justify-center">
          <span className="bg-error/10 ring-error/30 inline-flex h-20 w-20 items-center justify-center rounded-full ring-1">
            <TbAlertTriangle className="text-error size-10" />
          </span>
        </div>
        <h1 className="text-ink text-3xl font-semibold tracking-tight">Algo deu errado</h1>
        <p className="text-ink-muted mt-3 text-sm">
          Tivemos um problema inesperado ao carregar essa página. Tente novamente ou volte pra home.
        </p>
        {error.digest ? (
          <p className="text-ink-muted/70 mt-4 font-mono text-xs">ref: {error.digest}</p>
        ) : null}
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button variant="primary" size="md" onClick={() => reset()}>
            <TbRefresh className="size-4" /> Tentar novamente
          </Button>
          <Link href={'/' as never}>
            <Button variant="secondary" size="md">
              <TbHome className="size-4" /> Voltar pra home
            </Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}
